<template>
	<div class="uploadFiles">
		<div class="filesBg" v-if="show"></div>
		<div class="filesModal animated fadeIn" v-if="show">
			<div class="title">
				<h1>Subir documentos</h1>
			</div>
			<div class="body container" id="uploadFilesContainer" @click="removeDocument">
				<div class="document container">
					<div class="row form-group">
						<label for="" class="col-form-label col-sm-4">Tipo de documento</label>
						<div class="col-sm-8">
							<select name="" id="" class="form-control">
								<option v-for="tipo in tipos" :value="tipo.tag">{{ tipo.nombre }}</option>
							</select>
						</div>
					</div>
					<div class="row form-group">
						<label for="" class="col-form-label col-sm-4">Descripción</label>
						<div class="col-sm-8"><input type="text" class="form-control"></div>
					</div>
					<div class="row form-group">
						<label for="" class="col-form-label col-sm-4">Documento</label>
						<div class="col-sm-8"><input type="file" name=""></div>
					</div>
				</div>
			</div>
			<div class="footer">
				<button id="btn-addFile" class="btn btn-primary" style="margin-right: 5px" @click="addFile">Agregar documento</button>
				<button id="btn-uploadFiles" class="btn btn-success" style="margin-right: 5px" @click="confirmUpload">Subir documentos</button>
				<button id="btn-cancel" class="btn btn-danger" @click="cancelar">Cancelar</button>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import axios from 'axios'
	import Documento from '@/api/originacion/documentos'

	export default {
		name: 'vmodal'
		,props:{
			show: {
				type: Boolean
				,required: true
				,default: false
			}
			,solicitud: null
		}
		,data: function() {
			return {
				tipos: []
			}
		}
		,created: function() {
			Documento.types()
				.then((response) => {
					this.tipos = response;
				})
				.catch((err) => {
					console.log('err', err);
				});
		}
		,methods: {
			removeDocument: function(e) {
				if (e.target.matches('.btnQuit'))
					e.target.parentNode.remove();
			}
			,confirmUpload: function() {
				this.$swal({
					// type: 'success'
					title: 'Una vez subidos no podrás editar los documentos<br/>¿Deseas continuar?'
					// ,html: 'En breve nos comunicaremos con tigo por vía telefónica y por correo electrónico<br/>Solicitud con ID: <strong>'+res.data.data.solicitud_id+'</strong>'
					,showCancelButton: true
					,confirmButtonText: 'Si'
					,cancelButtonText: 'No'
					,reverseButtons: true
					// ,customClass: {
					// 	confirmButton: 'btn btn-danger'
					// 	,cancelButton: 'btn btn-success'
					// }
					// ,buttonsStyling: false
				})
				.then((res) => {
					if (res.value)
						this.uploadFiles();
				})
			}
			,uploadFiles: function() {
				// let url = process.env.VUE_APP_ORIGINACION_URL;
				// url += '/file'
				document.getElementById('btn-addFile').disabled = true;
				document.getElementById('btn-uploadFiles').disabled = true;
				document.getElementById('btn-cancel').disabled = true;
				document.querySelectorAll('.document .btnQuit').forEach((i) => {
					i.style.display = 'none';
				});

				let numObjs = document.querySelectorAll('.document').length-1;
				let numObj = 0;
				let errors = [];

				document.querySelectorAll('.document').forEach(async (item) => {

					Documento.upload({
						client_process_id: this.solicitud.process_id,
						cliente_id: this.solicitud.cliente_id,
						solicitud_id: this.solicitud.solicitud_id,
						type: item.getElementsByTagName('select')[0].value,
						description: item.getElementsByTagName('input')[0].value,
						file: item.getElementsByTagName('input')[1].files[0]
					})
					.then((res) => {
						// console.log('res', res);
						item.remove();
					})
					.catch((err) => {
						let error = '';

						if (err.response) {
							error = typeof(err.response.data.error) == 'object' ? err.response.data.error.join(',') : err.response.data.error;
						}else if (err.request) {
							error = err.request;
						}else
							error = err.message;

						item.style.backgroundColor = '#F2E0E1';

						let divError = document.createElement('div');
						item.appendChild(divError);

						divError.innerHTML = '<div class="row form-group">'
						+ '	<label for="" class="col-form-label col-sm-4">Error</label>'
						+ '	<div class="col-sm-8">'+error+'</div>'
						+ '</div>';
					});

					if (numObj == numObjs) {
						document.getElementById('btn-addFile').disabled = false;
						document.getElementById('btn-uploadFiles').disabled = false;
						document.getElementById('btn-cancel').disabled = false;

						document.querySelectorAll('.document .btnQuit').forEach((i) => {
							i.style.display = 'block';
						});
					}

					if (document.querySelectorAll('.document').length == 0) {
						this.$swal({
							type: 'success'
							,title: 'Todos los documentos se han subido correctamente'
						});

						this.$emit('update:show', false);
					}

					numObj++;
				});
			}
			,cancelar: function() {
				this.$swal({
					// type: 'success'
					title: '¿Realmente deseas cancelar?'
					// ,html: 'En breve nos comunicaremos con tigo por vía telefónica y por correo electrónico<br/>Solicitud con ID: <strong>'+res.data.data.solicitud_id+'</strong>'
					,showCancelButton: true
					,confirmButtonText: 'Si'
					,cancelButtonText: 'No'
					,reverseButtons: true
					,customClass: {
						confirmButton: 'btn btn-danger'
						,cancelButton: 'btn btn-success'
					}
					,buttonsStyling: false
				})
				.then((res) => {
					if (res.value)
						this.show = false;
				})
			}
			,addFile: function() {
				let container = document.getElementById('uploadFilesContainer');

				let doc = ''
				+ '	<div class="row form-group">'
				+ '		<label for="" class="col-form-label col-sm-4">Tipo de documento</label>'
				+ '		<div class="col-sm-8">'
				+ '			<select id="" class="form-control">';
				
				this.tipos.forEach((item) => {
					doc += '	<option value="'+item.tag+'">'+item.nombre+'</option>';
				});

				doc += '	</select>'
				+ '		</div>'
				+ '	</div>'
				+ '	<div class="row form-group">'
				+ '		<label for="" class="col-form-label col-sm-4">Descripción</label>'
				+ '		<div class="col-sm-8"><input type="text" class="form-control"></div>'
				+ '	</div>'
				+ '	<div class="row form-group">'
				+ '		<label for="" class="col-form-label col-sm-4">Documento</label>'
				+ '		<div class="col-sm-8"><input type="file" name=""></div>'
				+ '	</div>'
				+ '	<div class="btnQuit" title="Quitar documento">x</div>'
				+ '';

				let child = document.createElement('div');

				if (container) {
					container.appendChild(child);
					child.setAttribute('id', 'doc'+container.childNodes.length);
					child.innerHTML = doc;
					child.classList.add('document');
					child.classList.add('container');
					window.location.hash = '#doc'+container.childNodes.length;
				}
			}
		}
	}
</script>

<style lang="less">
	.uploadFiles {
		.filesBg {
			background-color: #666666;
			width: 100vw;
			height: 100vh;
			opacity: 0.6 !important;
			// transform: translate(-50%, -50%);
			position: fixed;
			top: 0px;
			left: 0px;
		}

		.filesModal {
			background-color: #fff;
			width: 70%;
			max-width: 900px;
			border: solid 1px #999999;
			border-radius: 5px;
			padding: 10px;
			transform: translate(-50%, -50%);
			overflow: auto;
			position: fixed;
			top: 50%;
			left: 50%;

			.title {
				h1 {
					font-size: 1.8em;
					font-weight: bold;
				}
			}

			.body {
				max-height: 60vh;
				margin: 10px 0px;
				overflow: auto;

				.document {
					border: solid 1px #E6E6E6;
					border-radius: 5px;
					margin-bottom: 10px;
					padding: 5px;
					position: relative;

					.btnQuit {
						background-color: #2A26AF;
						width: 20px;
						height: 20px;
						text-align: center;
						font-weight: bold;
						line-height: 1;
						color: #fff;
						border: solid 1px #2A26AF;
						border-radius: 9px;
						cursor: pointer;
						position: absolute;
						top: -3px;
						right: -3px;
					}
				}

				.document:nth-child(2n) {
					background-color: #F2F2F2;
				}
			}

			.footer {
				background-color: inherit;
				padding: 0px;
			}
		}

		.btn-success {
			margin-right: 5px;
		}
	}
</style>